import { createClient, type SupabaseClient } from '@supabase/supabase-js';

const DEFAULT_SUPABASE_URL = 'https://ksdpzzbnidqqimmtqbof.supabase.co';
const DEFAULT_SUPABASE_ANON_KEY =
  'sb_publishable_o98E68FrmIlaWWhOHIxG5A_xIiP8fUN';

const rawEnvUrl =
  typeof import.meta !== 'undefined'
    ? (import.meta as any).env?.VITE_SUPABASE_URL
    : undefined;
const rawEnvKey =
  typeof import.meta !== 'undefined'
    ? (import.meta as any).env?.VITE_SUPABASE_ANON_KEY
    : undefined;

export const SUPABASE_URL =
  rawEnvUrl &&
  String(rawEnvUrl).trim().startsWith('https://') &&
  !String(rawEnvUrl).includes('YOUR_PROJECT_ID') &&
  !String(rawEnvUrl).includes('placeholder')
    ? String(rawEnvUrl).trim()
    : DEFAULT_SUPABASE_URL;

export const SUPABASE_ANON_KEY =
  rawEnvKey &&
  String(rawEnvKey).trim().length > 20 &&
  !String(rawEnvKey).includes('YOUR_SUPABASE')
    ? String(rawEnvKey).trim()
    : DEFAULT_SUPABASE_ANON_KEY;

export const getEnvUrl = (): string => SUPABASE_URL;
export const getEnvAnonKey = (): string => SUPABASE_ANON_KEY;
export const isSupabaseConfigured = (): boolean => true;

export const supabase: SupabaseClient = createClient(
  SUPABASE_URL,
  SUPABASE_ANON_KEY,
  {
    auth: {
      persistSession: true,
      autoRefreshToken: true,
      detectSessionInUrl: true,
    },
  }
);

export const getSupabaseClient = (): SupabaseClient => supabase;
